import { render, staticRenderFns } from "./CustomerGroupPropertyTable.vue?vue&type=template&id=02dee3a2"
import script from "./CustomerGroupPropertyTable.vue?vue&type=script&lang=ts"
export * from "./CustomerGroupPropertyTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports